module.exports = "/legacy/762cf92d9fd13fd04203b22c56d839db.svg";